import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';

/* ★ v29.4：「数据源管理」（modalType = db_view-db_data_source）菜单配置。
   移植 lysync 的 global/sync_data_source.ts，差异：
   · 新建/修改弹窗组件换成 dbDataSourceConfig（本项目数据源无 source_type/custom_func）；
   · 无 AI模型生成（那是 lysync 的 aiGenModel，与本项目无关）；
   · 【连接测试】ok_url 指向 /db_view/check_connect（sqlview_ 前缀命名纪律），
     异步 Celery 检查后列表刷新可见彩色状态标签；
     不配 authority —— sqlview_* 接口未进 liyu_permission_apiurl（is_normal_api=True
     跳过权限块，v24 亦定案查询/工具类按钮不做权限校验），配了反而按无权限隐藏。 */
export default (_t, { model_app }) => {
  const btn_list: BtnListConfig = [
    {
      name: '修改',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '修改数据源',
        component: 'dbDataSourceConfig',
        init_data: {
          form_type: 'edit',
          model_app: model_app,
        },
      },
      authority: `${model_app}/update_db_data_source`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
    },
    {
      name: '连接测试',
      model_kind: 'confirm',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '连接测试',
        content: '是否确认要进行连接测试',
        ok_url: `${model_app}/check_connect`,
        api_fields: {
          data_source_id: 'id',
        },
      },
      order: 4,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
    },
  ];
  const head_btn_list: HeadBtnListConfig = [
    {
      name: '新建数据源',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '新建数据源',
        component: 'dbDataSourceConfig',
        init_data: {
          form_type: 'create',
          model_app: model_app,
        },
      },
      authority: `${model_app}/create_db_data_source`,
    },
  ];
  return {
    head_btn_list: head_btn_list,
    btn_list: btn_list,
    is_operation: [false, false, true, true],
  };
};
